import { render, staticRenderFns } from "./ClientRegisterComponent.vue?vue&type=template&id=ac85b526&scoped=true&"
import script from "./ClientRegisterComponent.vue?vue&type=script&lang=js&"
export * from "./ClientRegisterComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegisterComponent.vue?vue&type=style&index=0&id=ac85b526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac85b526",
  null
  
)

export default component.exports